<!-- new/existing installation -->
<div class="type-list">
  <div
    class="type-card"
    [class.active]="isNewSelected()"
    (click)="onNewSelected()"
  >
    <h2 class="type-card-title">{{ 'instType_new' | translate }}</h2>
    <p class="type-card-desc" [innerHTML]="'instType_newIntro' | translate"></p>
  </div>

  <div
    class="type-card"
    [class.active]="isExistingSelected()"
    (click)="onExistingSelected()"
  >
    <h2 class="type-card-title">{{ 'instType_existing' | translate }}</h2>
    <p
      class="type-card-desc"
      [innerHTML]="'instType_existingIntro' | translate"
    ></p>
    @if (isExistingSelected()) {
      <p
        class="type-card-desc extra"
        [innerHTML]="'instType_existingIntroExtra' | translate"
      ></p>
      <h3 class="installer-code">{{ installerCode() }}</h3>
    }
  </div>
</div>

<!-- button to submit selection -->
<div class="type-footer">
  <button class="btn-next" [disabled]="!isNewSelected()" (click)="submitType()">
    {{ btnText() | translate }}
  </button>
</div>
